import React from "react";
import logo from '../leclab-madrid-vertical.png'
import { Link } from "react-router-dom";

const CorporativeRegister = () => {
    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="card-header bg-transparent">
                <img width="100" className="mb-2" src={logo} />
                <h3>Solicitud Socio Corporativo de Leclab</h3>
            </div>
                <form className="form card-body text-start">
                <div className="row align-items-center justify-content-between my-3">
                    <div className="form-group col-sm-12 col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            name="firstname"
                            placeholder="Nombre Social *"
                            required
                        />
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            name="lastname"
                            placeholder="CIF *"
                            required
                        />
                    </div>
                </div>

                <div className="row align-items-center mb-3">
                    <div className="text-start col-sm-12 col-md-9">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Dirección Social"
                            required
                        />
                    </div>
                    <div className="col-sm-6 col-md-3">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="CP"
                            required
                        />
                    </div>
                </div>
                <div className="row align-items-center mb-1">
                    <div className="col-sm-12 col-md-4">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Ciudad"
                            required
                        />
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Provincia"
                            required
                        />
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="País"
                            required
                        />
                    </div>
                </div>
                <div className="row">
                    Añadir persona de contacto
                </div>
                <button type="submit" className="btn btn-login btn-block w-100 my-3">
                    Enviar Solicitud
                </button>
            </form>
                <div className="card-footer bg-transparent">
                <div>
                    Ya soy socio. <Link to="/" style={{ textDecoration: 'none' }}>Acceder</Link>
                </div>
            </div>
            </div >
        </div >
    )
};

export default CorporativeRegister;